import * as types from "../types/alertMessageTypes";
import { initialAlertState } from "../initialState";

export const alerts = (state = initialAlertState, action) => {
  switch (action.type) {
    case types.ERROR_ALERT:
      return action.alerts
    case types.INFO_ALERT:
      return action.alerts
    case types.SUCCESS_ALERT:
      return action.alerts
    case types.WARNING_ALERT:
      return action.alerts
    default:
      return state;
  }
};
